import { render, staticRenderFns } from "./freeToEnjoyDetail.vue?vue&type=template&id=e8dc269a&scoped=true"
import script from "./freeToEnjoyDetail.vue?vue&type=script&lang=js"
export * from "./freeToEnjoyDetail.vue?vue&type=script&lang=js"
import style0 from "./freeToEnjoyDetail.vue?vue&type=style&index=0&id=e8dc269a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8dc269a",
  null
  
)

export default component.exports